import { Factory, Globe2, UserCog, Rocket } from "lucide-react";
import Promises from "./promises";
import Values from "./values";
import { useTranslation } from "../../../../i18n/useTranslation";
import { useScrollToHash } from "../../../../hooks/useScrollToHash";

const ICONS = [Factory, Globe2, UserCog, Rocket];

const TrustedEcosystem = () => {
  const { t } = useTranslation();
  const modelTitles = t("trustedEcosystem.model");
  useScrollToHash();

  return (
    <div>
      <div className="band-hero section text-center">
        <div className="eyebrow">{t("trustedEcosystem.eyebrow")}</div>
        <h1>{t("trustedEcosystem.headingLine1")}<br />{t("trustedEcosystem.headingLine2")}</h1>
        <div className="max-w-xl mx-auto pt-3">
          <p className="mini">{t("trustedEcosystem.intro")}</p>
        </div>
      </div>

      <div className="band-a section-tight">
        <div className="max-w-2xl mx-auto text-center px-5">
          <div className="eyebrow">{t("trustedEcosystem.structureEyebrow")}</div>
          <h2>{t("trustedEcosystem.structureHeading")}</h2>
          <p className="mini pt-2">{t("trustedEcosystem.structureIntro")}</p>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 px-5 py-8">
          {ICONS.map((Icon, i) => (
            <div key={i} className="card-ledger text-center">
              <Icon className="mx-auto" size={40} strokeWidth={1.5} style={{ color: "var(--gold)" }} />
              <h4 className="pt-2">{modelTitles[i]}</h4>
            </div>
          ))}
        </div>
      </div>

      <Promises />
      <Values />

      <div className="band-b section-tight text-center">
        <div className="eyebrow">{t("trustedEcosystem.nextEyebrow")}</div>
        <h2>{t("trustedEcosystem.nextHeading")}</h2>
        <div className="max-w-xl mx-auto pt-2">
          <p className="mini">{t("trustedEcosystem.nextIntro")}</p>
        </div>
      </div>
    </div>
  );
};

export default TrustedEcosystem;
